import { IsoDateTimeTz } from '../../types/iso-date';

export function isIsoDateTimeTz(dateTime: string): dateTime is IsoDateTimeTz {
  // Strict ISO 8601 with timezone:
  // YYYY-MM-DDTHH:mm:ss(.fraction[1-6])?(Z|±HH:MM)
  const re =
    /^(\d{4})-(\d{2})-(\d{2})T([01]\d|2[0-3]):([0-5]\d):([0-5]\d)(?:\.(\d{1,6}))?(?:Z|([+-])([01]\d|2[0-3]):([0-5]\d))$/;
  const m = re.exec(dateTime);
  if (!m) return false;

  const year = Number(m[1]);
  const month = Number(m[2]);
  const day = Number(m[3]);
  const hour = Number(m[4]);
  const minute = Number(m[5]);
  const second = Number(m[6]);
  const fraction = m[7];
  const sign = m[8]; // '+' | '-' | undefined (when 'Z')
  const tzHour = m[9] !== undefined ? Number(m[9]) : undefined;
  const tzMinute = m[10] !== undefined ? Number(m[10]) : undefined;

  // Enforce realistic offset bounds if offset is present (not Z)
  if (sign) {
    // Guard: if a sign is captured, tzHour and tzMinute must also be captured by the regex
    if (tzHour === undefined || tzMinute === undefined) return false;
    if (sign === '+') {
      // +14:00 is maximum; when 14, minutes must be 00
      if (tzHour > 14) return false;
      if (tzHour === 14 && tzMinute !== 0) return false;
    } else {
      // -12:00 is minimum; when 12, minutes must be 00
      if (tzHour > 12) return false;
      if (tzHour === 12 && tzMinute !== 0) return false;
    }
  }

  // Validate calendar/time by constructing a Date and comparing components
  const ms = fraction ? Number((fraction + '000').slice(0, 3)) : 0;
  const d = new Date(year, month - 1, day, hour, minute, second, ms);
  return (
    d.getFullYear() === year &&
    d.getMonth() === month - 1 &&
    d.getDate() === day &&
    d.getHours() === hour &&
    d.getMinutes() === minute &&
    d.getSeconds() === second
  );
}

